import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager, useApplicationState } from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

const BLOCK_DURATION_HOURS = 72;

const getUnblockDate = (startTimestamp, limitHours) => {
  const normalizedStart =
    String(startTimestamp).length === 10 ? startTimestamp * 1000 : startTimestamp;

  const unblockTimeMs = normalizedStart + limitHours * 60 * 60 * 1000;

  return new Date(unblockTimeMs).toLocaleString('en-US', {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const AccountBlockedPopup = ({ id }) => {
  const { account } = useApplicationState();
  const handleClose = useCallback(() => NotificationManager.removeNotification(id), [id]);
  const sigapLimitedAt = account.additionalParameters?.SIGAP_ACCESS_LIMITED_AT;

  const duration = getUnblockDate(Number(sigapLimitedAt), BLOCK_DURATION_HOURS);

  return (
    <BasePopup className="account-blocked">
      <div className="account-blocked__content">
        <Icon className="account-blocked__content-icon" name="alert" />
        <Label className="account-blocked__content-title" message="blocking_popup_title" />
        <Label
          className="account-blocked__content-text"
          message="blocking_popup_your_account_blocked"
        />
        <Label
          className="account-blocked__content-text-bold"
          message="blocking_popup_withdrwaw_funds"
          params={{ sigap_limited_period: duration }}
        />
        <Label className="account-blocked__content-text" message="blocking_popup_contact_support" />
      </div>
      <div className="account-blocked__footer">
        <Button
          className="account-blocked__footer-button"
          label="blocking_popup_button"
          onClick={handleClose}
          size="big"
          type="secondary"
        />
      </div>
    </BasePopup>
  );
};

AccountBlockedPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
